// import config from "./config";
import {
  history
} from "../_helpers";

export const userService = {
  login,
  logout
};

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      username,
      password
    })
  };

  return fetch(`http://15.206.132.121:3002/api/adminLogin`, requestOptions)
    .then(handleResponse)
    .then(user => {
      if (user.success === false) {
        throw user.message.text;
      }
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user));
      return user;
    }).catch(err => {
      throw err;
    })
    ;
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  history.push('/admin/login')
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401 || response.status === 500 || response.status === 400) {
        // auto logout if 401 response returned from api
        logout();
        //  location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}